module.exports = __webpack_public_path__ + "img/Yostar_Websit_Bg@3x.6d82c9ea.png";